import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import facebook from 'components/assets/img/logo/testimonials/facebook.svg';
import google from 'components/assets/img/logo/testimonials/google.svg';
import Slider from 'react-slick';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';

class CustomSlide extends Component {
  render() {
    const { author, blockquote, index, logo, logoAlt, url } = this.props;
    return (
      <div className="testimonials-list__item">
        <blockquote>{blockquote}</blockquote>
        <div className="testimonials__footer">
          <h4>{author}</h4>
          <p>
            <T>content.landing.homepage.testimonials.footer.title</T>
            {' '}
            <a href={'http://' + url} target="_blank">{url}</a>
          </p>
          <img src={logo} alt={logoAlt} />
        </div>
      </div>
    );
  }
}

class Testimonials extends Component {

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.landing.homepage.testimonials.' + key);
  }

  render() {

    var settings = {
      arrows: false,
      className: 'testimonials-list',
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            centerPadding: '10px',
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 640,
          settings: {
            centerPadding: '0',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (

      <section className="testimonials">
        <div className="row">
          <div className="headline">
            <h2><T>content.landing.homepage.testimonials.title</T></h2>
            <p><T>content.landing.homepage.testimonials.description</T></p>
          </div>

          <Slider {...settings}>
            <CustomSlide
              index={1}
              author={this.trans('items.first.author')}
              blockquote={this.trans('items.first.content')}
              logo={facebook}
              logoAlt={this.trans('items.first.logoAlt')}
              url={this.trans('items.first.url')}
            />
            <CustomSlide
              index={2}
              author={this.trans('items.second.author')}
              blockquote={this.trans('items.second.content')}
              logo={facebook}
              logoAlt={this.trans('items.second.logoAlt')}
              url={this.trans('items.second.url')}
            />
            <CustomSlide
              index={3}
              author={this.trans('items.third.author')}
              blockquote={this.trans('items.third.content')}
              logo={google}
              logoAlt={this.trans('items.third.logoAlt')}
              url={this.trans('items.third.url')}
            />
            <CustomSlide
              index={4}
              author={this.trans('items.fourth.author')}
              blockquote={this.trans('items.fourth.content')}
              logo={google}
              logoAlt={this.trans('items.fourth.logoAlt')}
              url={this.trans('items.fourth.url')}
            />
          </Slider>
        </div>
      </section>
    );
  }
}

export default Testimonials;